class ReplaceTriangle {
  constructor(character) {
    this.character = character;
    console.log(this.character);
    this.replace();
  }

  replace() {
    document.querySelectorAll("*:not(script)").forEach(el => {
      el.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(this.character)) {
          let newText = node.textContent.replaceAll(this.character, `<span class="yellow">${this.character}</span>`);
          let span = document.createElement("span");
          span.innerHTML = newText;
          node.parentElement.replaceChild(span, node);
        }
      });
    });
  }
}

export default ReplaceTriangle;
